import { useState } from 'react';

import { useQueryClient } from 'react-query';
import { useHistory, useLocation } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useMutationDeleteUserGroup } from 'api/mutations/deleteUserGroup.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Settings/Components/UserGroups/components/userGroups.module.scss';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';

export const RowOptionsCell = ({ row }) => {
    const { group_name, group_id } = row.original;
    const [show, setShow] = useState<boolean>(false);
    const history = useHistory();
    const { pathname } = useLocation();
    const mutation = useMutationDeleteUserGroup();
    const { customerId } = useUserHook();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const handleEdit = () => {
        history.push(`${pathname}/${settingsConfig.userGroupsEdit.link}/${group_id}`);
    };

    const handleDelete = () => {
        if (!customerId) return null;
        mutation.mutate(
            {
                customer_id: customerId,
                group_name,
            },
            {
                onSuccess: () => {
                    handleSnackBar('Successfully deleted!', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    queryClient.invalidateQueries('getAllUserGroups');
                },
            },
        );
        setShow(false);
    };

    return (
        <div className={classes.actions}>
            <CustomizedRoundIcon onClick={handleEdit}>
                <Icon name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <MuiIcon icon={'delete'} type={'outlined'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete group ${group_name}?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
